const zozoDialog = document.getElementById("zozoDialog");
const productDetails = document.getElementById("productDetails");
const position = document.getElementById("dialogPosition");
const optionSelectors = document.getElementById("optionSelectors");
const body = document.body;

const showZozoDialog = () => {
  body.appendChild(zozoDialog);
  const scrollY = window.scrollY + "px";
  body.style.position = "fixed";
  body.style.top = `-${scrollY}`;
  setTimeout(function () {
    zozoDialog.classList.add("show");
  }, 100);
};
const closeDialog = () => {
  const scrollY = body.style.top;
  body.style.position = "";
  body.style.top = "";
  window.scrollTo(0, parseInt(scrollY || "0") * -1);
  zozoDialog.classList.remove("show");
  setTimeout(function () {
    productDetails.insertBefore(zozoDialog, position);
  }, 300);
};
// window.addEventListener('scroll', () => {
//   document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
// });

const showZozoDialogButton = document.getElementById("showZozoDialog");
if (showZozoDialogButton) {
  const closeDialogButtons = [document.getElementById("dialogCloseIcon"), document.getElementById("dialogCloseText")];
  showZozoDialogButton.addEventListener("click", () => {
    showZozoDialog();
  });
  closeDialogButtons.forEach((e) => {
    e.addEventListener("click", () => {
      closeDialog();
    });
  });
}

const addToCartButtonFunction = (entries) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
      console.log(entry);
      dialogPosition.animate([{ transform: "translateY(0)" }], {
        fill: "forwards",
        easing: "ease-in",
        duration: 500,
      });
    } else {
      dialogPosition.animate([{ transform: "translateY(100px)" }], {
        fill: "forwards",
        easing: "ease-in",
        duration: 500,
      });
    }
  });
};

const addToCartMain = document.getElementById("add-to-cart-main");
const zozoObserver = new IntersectionObserver(addToCartButtonFunction);
if (addToCartMain) {
  zozoObserver.observe(addToCartMain);
}
